import React, { Component } from "react";
import _ from "lodash";
import { Form, Input, Tabs, message } from "antd";
import { Field, reduxForm, getFormValues } from "redux-form";
import { connect } from "react-redux";

const { TextArea } = Input;
const TabPane = Tabs.TabPane;
const FormItem = Form.Item;

class HighlighProductModal extends Component {
  constructor(props) {
    super(props);

    const { products, highlightProduct } = props;

    let displayProduct = null;
    if (highlightProduct && highlightProduct.product_id) {
      displayProduct = products[highlightProduct.product_id];
      displayProduct["productId"] = highlightProduct.product_id;
    }

    this.state = {
      product: displayProduct,
      activeTabKey: "en",
      short_desc: {
        en: "",
        th: "",
        zh: "",
      },
    };
  }

  componentWillReceiveProps(nextProps) {
    const { products, highlightProduct } = nextProps;

    let displayProduct = null;
    if (highlightProduct && highlightProduct.product_id) {
      displayProduct = products[highlightProduct.product_id];
      displayProduct["productId"] = highlightProduct.product_id;
    }

    this.setState({
      product: displayProduct,
    });
  }

  onProductDropdownClick(product, key) {
    this.setState({ product: { ...product, productId: key } });
  }

  // onFileChooserChange(e) {
  //     const files = e.target.files;

  //     if (files.length > 0) {
  //         this.setState({ imageFile: files[0] });
  //     }
  //     console.log(files);
  // }

  onTabChange(key) {
    this.setState({ activeTabKey: key });
  }

  renderTextAreaField(field) {
    const {
      meta: { touched, error },
      input,
    } = field;
    const className = `form-group txt-area`;
    const validationStatus = `${touched ? (error ? "error" : "success") : ""}`;
    const help = `${touched && error ? error : ""}`;

    return (
      <FormItem
        label={field.label}
        colon
        className={className}
        required={field.required}
        validateStatus={validationStatus}
        help={help}
      >
        <TextArea
          className="form-control"
          placeholder={field.placeholder}
          autosize={{ minRows: 5, maxRows: 9 }}
          {...input}
        />
      </FormItem>
    );
  }

  onSubmitButtonClick() {
    const { short_desc, product } = this.state;

    if (short_desc && product) {
      const { onAdd } = this.props;
      onAdd(short_desc, product.productId);
    }
  }

  onUpdateButtonClick() {
    const { hlValues, highlightProduct } = this.props;

    if (hlValues && highlightProduct) {
      const { onUpdate } = this.props;
      onUpdate(hlValues, highlightProduct.id);
    }
  }

  renderProductsDropdown() {
    const { product } = this.state;
    const { products } = this.props;

    const rows = _.map(products, (product, key) => {
      return (
        <li key={key}>
          <a
            className="dropdown-item"
            onClick={() => this.onProductDropdownClick(product, key)}
          >
            {product.name_en}
          </a>
        </li>
      );
    });

    return (
      <div className="form-group select-dropdown">
        <label htmlFor="dropdown">Product:</label>
        <div className="form-group dropdown form-dropdown">
          <button
            className="btn dropdown-toggle form-list selected"
            type="button"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >
            {product ? product.name_en : "Select a Product"}
          </button>
          <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton">
            {rows}
          </ul>
        </div>
      </div>
    );
  }

  render() {
    const { onCancel, highlightProduct, products, hlValues } = this.props;
    const { activeTabKey } = this.state;

    return (
      <div className="modal-body">
        <form onSubmit={(e) => e.preventDefault()}>
          <h3>Add Highlight Product</h3>
          {this.renderProductsDropdown()}
          {/*<div className="form-group browse-file">
                        <label htmlFor="custom-file">Image:
                                <span>(Recommend 2:1 e.g., 1200x600px)</span>
                        </label>
                        <label className="custom-file">
                            <input
                                type="file"
                                id="file2"
                                className="custom-file-input"
                                accept="image/*"
                                onChange={this.onFileChooserChange.bind(this)}
                            />
                            <span className="custom-file-control">
                                {imageFile ? imageFile.name : null}
                            </span>
                        </label>
                    </div>*/}
          <div />
          <div className="form-group">
            <label>{"Short Description"}:</label>
            <div className="form-group txt-area has-tabs">
              <Tabs
                activeKey={activeTabKey}
                onChange={this.onTabChange.bind(this)}
                animated={false}
              >
                <TabPane tab="English" key="en">
                  <Field
                    name="short_desc_en"
                    label="Short Description (EN)"
                    placeholder="Short Description (English)"
                    component={this.renderTextAreaField}
                  />
                </TabPane>
                <TabPane tab="Thai" key="th">
                  <Field
                    name="short_desc_th"
                    label="Short Description (TH)"
                    placeholder="Short Description (Thai)"
                    component={this.renderTextAreaField}
                  />
                </TabPane>
                <TabPane tab="Chinese" key="zh">
                  <Field
                    name="short_desc_zh"
                    label="Short Description (ZH)"
                    placeholder="Short Description (Chinese)"
                    component={this.renderTextAreaField}
                  />
                </TabPane>
              </Tabs>
            </div>
          </div>
          <div className="modal-botton">
            <button className="btn button gray-btn" onClick={onCancel}>
              Cancel
            </button>
            {highlightProduct && (
              <button
                className="btn button green-btn"
                onClick={() => this.onUpdateButtonClick()}
              >
                Update Highlight
              </button>
            )}
            {!highlightProduct && (
              <button
                className="btn button green-btn"
                onClick={() => this.onSubmitButtonClick()}
              >
                Add Highlight
              </button>
            )}
          </div>
        </form>
      </div>
    );
  }
}

function validate(values) {
  //   console.log("validate", values);
  const errors = {};
  if (values.short_desc ? !values.short_desc.en : false) {
    errors.short_desc_en = "Product must have description";
  }

  return errors;
}

HighlighProductModal = reduxForm({
  validate,
  form: "HighlighForm",
  enableReinitialize: true,
})(HighlighProductModal);

export default connect((state) => {
  //   console.log("state", mapStateToProps.product);
  let enTxt = "";
  let thTxt = "";
  let zhTxt = "";
  if (state.product.highlightProduct) {
    const selected = state.product.highlightProduct;
    enTxt = selected.short_desc.en;
    thTxt = selected.short_desc.th;
    zhTxt = selected.short_desc.zh;
  }
  return {
    // alternatively, you can set initial values here...
    initialValues: {
      short_desc_en: enTxt,
      short_desc_th: thTxt,
      short_desc_zh: zhTxt,
    },
    hlValues: getFormValues("HighlighForm")(state),
  };
})(HighlighProductModal);



// WEBPACK FOOTER //
// ./src/views/products/HighlightProductModal.js